import React from "react";
import Alert from "@mui/joy/Alert";

export default function Alerta({
  color,
  startDecorator,
  contenido,
  encendido,
}) {
  let estado = { encendido };

  return (
    <div>
      {encendido ? (
        <Alert
          variant="soft"
          className="notificacion"
          color={color}
          startDecorator={startDecorator}
        >
          {contenido}
        </Alert>
      ) : null}
    </div>
  );
}
